/* build/tpl */
import deps from './deps/condenseDeep.js';
import getCondenseDeep from './getCondenseDeep.js';
export default getCondenseDeep(deps);
